import { __decorate } from "tslib";
import { date, QBtn, QCard, QCardSection, QDialog, QIcon, QItem, QItemLabel, QItemSection, QList, QPage, QSelect, QTable, QTd, QTr, } from 'quasar';
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { EControllerState } from '@/store/Controller';
const profileStore = namespace('ProfileStore');
const controllerStore = namespace('ControllerStore');
const versionStore = namespace('VersionStore');
const waringStore = namespace('WarningStore');
let Index = class Index extends Vue {
    constructor() {
        super(...arguments);
        this.loading = true;
        this.date = date;
        this.result = null;
        this.showResultModal = false;
        this.stateFilter = null;
        this.stateFilterOptions = [
            {
                label: 'Healthy',
                value: EControllerState.HEALTHY,
            },
            {
                label: 'Warning',
                value: EControllerState.WARNING,
            },
            {
                label: 'Unconfigured',
                value: EControllerState.UNCONFIGURED,
            },
            {
                label: 'Offline',
                value: EControllerState.OFFLINE,
            },
            {
                label: 'Updating',
                value: EControllerState.UPDATING,
            },
        ];
    }
    async created() {
        try {
            await this.fetchVersions();
            await this.fetchWarnings();
            await this.fetchControllers();
        }
        finally {
            this.loading = false;
        }
    }
    get rows() {
        return this.controllers.map((c) => {
            return {
                ...c,
                warnings: this.getWarnings(c),
            };
        });
    }
    async setVersion(value) {
        await this.updateVersion(value.value);
        await this.fetchControllers();
    }
    versionOptions(controller) {
        return this.versions.map((version) => {
            return {
                label: version,
                value: {
                    controller,
                    version,
                },
            };
        });
    }
    disableVersion(controller, version) {
        return (controller.state === EControllerState.UPDATING ||
            this.versions.length === 0 || (this.versions.length === 1 &&
            this.versions[0] === version));
    }
    async showUpdateResult(cID) {
        await this.fetchUpdateResult(cID);
        this.updateResult.output = atob(this.updateResult.output); // Decode Base64
        this.showResultModal = !this.showResultModal;
    }
    stateFilterMethod(rows, filter) {
        return rows.filter((v) => {
            return v.state === filter.value;
        });
    }
    get columns() {
        const c = [
            {
                name: 'id',
                label: '#',
                sortable: true,
                align: 'center',
                field: (row) => row.id,
            },
            {
                name: 'name',
                label: 'name',
                align: 'left',
                sortable: true,
                field: (row) => row.name,
            },
        ];
        if (!this.isAdmin) {
            return c;
        }
        return [
            ...c,
            {
                name: 'version',
                label: 'version',
                align: 'right',
                field: (row) => row.version,
            },
            {
                name: 'update-result',
                label: 'update result',
                align: 'left',
                field: (row) => row.name,
            },
            {
                name: 'warning',
                label: '',
                align: 'center',
                field: (row) => row.state,
            },
        ];
    }
    get isAdmin() {
        if (!this.profile) {
            return false;
        }
        return this.profile.role === `admin`;
    }
};
__decorate([
    controllerStore.State('controllers')
], Index.prototype, "controllers", void 0);
__decorate([
    profileStore.State('profile')
], Index.prototype, "profile", void 0);
__decorate([
    controllerStore.State('updateResult')
], Index.prototype, "updateResult", void 0);
__decorate([
    controllerStore.Action('updateVersion')
], Index.prototype, "updateVersion", void 0);
__decorate([
    waringStore.Action('fetch')
], Index.prototype, "fetchWarnings", void 0);
__decorate([
    waringStore.Getter('warning')
], Index.prototype, "getWarnings", void 0);
__decorate([
    controllerStore.Action('fetch')
], Index.prototype, "fetchControllers", void 0);
__decorate([
    controllerStore.Action('fetchUpdateResult')
], Index.prototype, "fetchUpdateResult", void 0);
__decorate([
    versionStore.Action('fetch')
], Index.prototype, "fetchVersions", void 0);
__decorate([
    versionStore.State('versions')
], Index.prototype, "versions", void 0);
__decorate([
    profileStore.Action('fetch')
], Index.prototype, "fetchProfile", void 0);
Index = __decorate([
    Component({
        components: {
            QBtn,
            QCard,
            QCardSection,
            QDialog,
            QIcon,
            QItem,
            QItemLabel,
            QItemSection,
            QList,
            QPage,
            QSelect,
            QTable,
            QTd,
            QTr,
        },
    })
], Index);
export default Index;
